<template>
  <div class="editUserContact">
    <el-button
          type="primary"
          size="small"
          class="editCount"
          v-show="!isEdit"
          @click="editCount"
        >
          编辑
    </el-button>
    <el-form
      :model="authRuleForm"
      :rules="rules"
      ref="ruleFormAddCount"
      label-width="150px"
    >
      <el-form-item label="账户名" prop="account" class="account-prompt-content">
        <el-input
          v-model="authRuleForm.account"
          :disabled="!isEdit"
          :maxlength="32"
          placeholder=""
        ></el-input>
        <p class="label-tips">
          需与基本配置中的Username属性保持一致
        </p>
      </el-form-item>
      <el-form-item label="姓" prop="surname">
        <el-input
          :disabled="!isEdit"
          v-model="authRuleForm.surname"
          :maxlength="32"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="名" prop="name">
        <el-input
          :disabled="!isEdit"
          v-model="authRuleForm.name"
          :maxlength="32"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input
          :disabled="!isEdit"
          v-model="authRuleForm.email"
          :maxlength="32"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="phone">
        <el-input
          :disabled="!isEdit"
          v-model="authRuleForm.phone"
          :maxlength="32"
          placeholder=""
        ></el-input>
      </el-form-item>
      <el-form-item>
        <div class="footer" v-show="isEdit">
          <el-button type="primary" @click="submitForm">确 定</el-button>
          <el-button @click="handleCancel">取 消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
/* import { validatePhone } from "@/common/utils.js" */
/* import APIS from "@/apis/userManage.js" */
import ContactAPIS from "@/apis/userContact.js"
export default {
  components: {},
  props: {
    authRuleForm: {
      type: Object,
      default: () => {}
    },
    authMapping: {
      type: Array,
      default: () => []
    },
    accountId: {
      type: String,
      default: () => ""
    }
  },
  data() {
    return {
      breadcrumb: [
        {
          label: "用户联合",
          url: "/userContact"
        },
        {
          label: "用户联合详情"
        }
      ],
      isEdit: false,
      moduleTitle: "",
      ruleForm: {
        countName: "",
        userName: "",
        phone: "",
        email: "",
        enable: true,
        department: [],
        managered: false
      },
      preParams: {},
      rules: {
        account: [{ required: true, message: "请输入LDAP对应的属性字段", trigger: "blur" }],
        email: [{ required: true, message: "请输入LDAP对应的属性字段", trigger: "blur" }],
        surname: [{ min: 0, max: 10000, message: '长度在 0 到 10000 个字符', trigger: 'blur' }],
        name: [{ min: 0, max: 10000, message: '长度在 0 到 10000 个字符', trigger: 'blur' }],
        phone: [{ min: 0, max: 10000, message: '长度在 0 到 10000 个字符', trigger: 'blur' }]
      },
      realmName: this.$realm //this.$realm,
    }
  },
  computed: {},
  mounted() {},
  methods: {
    editCount() {
      this.preParams = JSON.stringify({
        authRuleForm: this.authRuleForm
      })
      this.isEdit = true
    },
    async addUser() {
      this.authMapping.forEach(item => {
        if(item.name === '账户名'){
          item.ldapAtt = this.authRuleForm.account
        } else if(item.name === '邮箱') {
          item.ldapAtt = this.authRuleForm.email
        } else if(item.name === '姓') {
          item.ldapAtt = this.authRuleForm.surname
        } else if(item.name === '名') {
          item.ldapAtt = this.authRuleForm.name
        } else {
          item.ldapAtt = this.authRuleForm.phone
        }
      });
      let { status } = await ContactAPIS.putRealmsUserContactMap(
        this.realmName,
        this.accountId,
        { data: this.authMapping }
      )
      if (status === 0) {
         this.isEdit = false
        this.$emit('getUserContactInfor')
      }
    },
    // 提交添加账户表单
    submitForm() {
      this.$refs["ruleFormAddCount"].validate(valid => {
        if (valid) {
          this.addUser()
        }
      })
    },
    handleCancel() {
      this.isEdit = false
      this.$refs["ruleFormAddCount"].resetFields()
      this.$emit('cancel')
    }
  }
}
</script>

<style lang="scss">
.editUserContact {
  .el-form{
    width: 600px;
  }
  .account-prompt{
    color:#454647;
    font-size: 12px;
    line-height: 1;
    padding-top: 4px;
    position: absolute;
    top: 85%;
    left: 0;
  }
  .account-prompt-content{
    margin-bottom:25px;
    .el-form-item__error{
      margin-top: 1px;
    }
  }
  .name {
    margin-bottom: 16px;
    padding-left: 26px;
  }
  .el-form-item__error {
    white-space: nowrap;
  }
  .testServer{
    .el-button{
      position: absolute;
      top: 5px;
      right: 0;
    }
  }
  .el-form-item__content {
    .testTip {
      color: #999;
      font-size: 13px;
      margin-left: 20px;
      vertical-align: middle;
    }
    .el-button--text {
      position: absolute;
      margin-left: 14px;
      top: 6px;
    }
    .el-select{
      width: 100%;
    }
    .el-input-number{
      width: 100%;
    }
  }
}
</style>
